module.exports = __webpack_public_path__ + "static/img/banner2.9bdacda.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner2.jpg
// module id = 2f6r
// module chunks = 12